import { __rest, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useDropdownContext } from '../Dropdown/DropdownProvider.js';
import { Popover } from '../Popover/Popover.js';
import { positionMatchWidth } from '../Popover/usePopover.js';
import { Box } from '../Box/index.js';
import 'react';
import '../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../hooks/useTheme.js';
import { SelectLegacyDropdownOptions } from './SelectLegacyDropdownOptions.js';

var SelectLegacyDropdown = function (_a) {
    var children = _a.children, type = _a.type, sx = _a.sx;
    var dropdownContext = useDropdownContext();
    var contentRef = dropdownContext.contentRef, keyDownHandler = dropdownContext.keyDownHandler, popoverRef = dropdownContext.popoverRef, triggerRef = dropdownContext.triggerRef, isOpen = dropdownContext.isOpen;
    var _b = useTheme(), handleStyleProps = _b.handleStyleProps, mergeStyles = _b.mergeStyles;
    var css = handleStyleProps({ sx: sx }).css;
    var dropdownCss = handleStyleProps({ type: type }, { themeKey: "selectDropdown" }).css;
    var width = css.width, maxWidth = css.maxWidth, cssRest = __rest(css, ["width", "maxWidth"]);
    var popoverSx = mergeStyles([
        __assign({ minWidth: "inherit" }, dropdownCss),
        cssRest,
    ]);
    return (jsx(Popover, __assign({ ref: popoverRef, hidden: !isOpen, targetRef: triggerRef, position: positionMatchWidth, sx: popoverSx }, { children: isOpen && (jsx(Box, __assign({ "data-dropdown": true, sx: { width: width, maxWidth: maxWidth }, ref: contentRef, onKeyDown: keyDownHandler }, { children: children || jsx(SelectLegacyDropdownOptions, {}) }))) })));
};
SelectLegacyDropdown.displayName = "SelectLegacyDropdown";

export { SelectLegacyDropdown };
//# sourceMappingURL=SelectLegacyDropdown.js.map
